import Vue from 'vue'
import { API_URL } from '@/config'
import router from '@/router'

export const meeting = {

  namespaced: true,

  state: {
    meeting: {},
  },

  getters: {
    meeting: state => state.meeting,
  },

  mutations: {
    setMeeting(state, meeting) { state.meeting = meeting },
  },

  actions: {

    async getMeeting({ commit }) {
      const meeting = await Vue.axios.get(API_URL + '/meetings/' + router.currentRoute.params.id);
      commit('setProgress', false, { root: true });
      commit('setMeeting', meeting.data);
    },

  }
}
